import { render, staticRenderFns } from "./SupplierUpcomingDueTable.vue?vue&type=template&id=7059e068"
import script from "./SupplierUpcomingDueTable.vue?vue&type=script&lang=ts"
export * from "./SupplierUpcomingDueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports